module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-12.9b7e1e0f.jpg";